import React from 'react';

const AdminPage = () => {
  return (
    <div>
      <h1>Acceso permitido</h1>
      <h4>Saludos, ya puedes acceder a cualquier sección para editarla.
      No olvides pulsar el botón Logout, en la cabecera, para cerrar la sesión.</h4>
    </div>
  );
};

export default AdminPage;